// notation.js
// Hamle kayıtlarını okunabilir metne çeviren paylaşılan yardımcılar (TR/EN).
// MoveHistory.jsx (canlı oyun) ve ProfilePage.jsx (kaydedilmiş oyunlar) kullanır.

import { PIECE_NAMES } from './ShogiEngine';

// row/col (0-8) -> geleneksel kare etiketi: sütun 9-1 (soldan sağa), sıra 1-9 (yukarıdan aşağı)
export function squareLabel(pos) {
  if (!pos) return '?';
  const file = 9 - pos.col;
  const rank = pos.row + 1;
  return `${file}${rank}`;
}

const TEXT = {
  tr: { drop: (p, sq) => `${p} elden ${sq} karesine kondu`, promoted: '(terfi etti)', captured: (p) => `— ${p} alındı` },
  en: { drop: (p, sq) => `${p} dropped on ${sq}`, promoted: '(promoted)', captured: (p) => `— captured ${p}` },
};

export function describeMove(m, lang = 'tr') {
  const tx = TEXT[lang] || TEXT.tr;
  const label = PIECE_NAMES[m.piece] || m.piece;
  if (m.type === 'drop') return tx.drop(label, squareLabel(m.to));
  const parts = [`${label} ${squareLabel(m.from)} → ${squareLabel(m.to)}`];
  if (m.promote) parts.push(tx.promoted);
  if (m.captured) parts.push(tx.captured(PIECE_NAMES[m.captured] || m.captured));
  return parts.join(' ');
}
